import { render, staticRenderFns } from "./static-action.vue?vue&type=template&id=964b5b30&scoped=true"
import script from "./static-action.vue?vue&type=script&lang=js"
export * from "./static-action.vue?vue&type=script&lang=js"
import style0 from "./static-action.vue?vue&type=style&index=0&id=964b5b30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../legacy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964b5b30",
  null
  
)

export default component.exports